interface WebsiteIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}

export function WebsiteIcon({ color = 'currentColor', ...svgProps }: WebsiteIconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M11.3571 18L10.9866 16.4157C10.8481 15.8277 10.7321 15.2566 10.6385 14.7022H10.6273C10.5337 15.2566 10.4177 15.8277 10.2792 16.4157L9.9087 18H8.83646L8 14H8.80839L9.0947 15.4551C9.21446 16.0618 9.31176 16.6386 9.38661 17.1854H9.39784C9.49889 16.6199 9.62052 16.0431 9.76274 15.4551L10.1108 14H11.155L11.503 15.4551C11.6452 16.0431 11.7669 16.6199 11.8679 17.1854H11.8791C11.954 16.6386 12.0513 16.0618 12.1711 15.4551L12.4574 14H13.2658L12.4293 18H11.3571Z"
        fill={color}
      />
      <path
        d="M16.7242 18L16.3537 16.4157C16.2152 15.8277 16.0992 15.2566 16.0056 14.7022H15.9944C15.9008 15.2566 15.7848 15.8277 15.6463 16.4157L15.2758 18H14.2036L13.3671 14H14.1755L14.4618 15.4551C14.5816 16.0618 14.6789 16.6386 14.7537 17.1854H14.765C14.866 16.6199 14.9876 16.0431 15.1299 15.4551L15.4779 14H16.5221L16.8701 15.4551C17.0124 16.0431 17.134 16.6199 17.235 17.1854H17.2463C17.3211 16.6386 17.4184 16.0618 17.5382 15.4551L17.8245 14H18.6329L17.7964 18H16.7242Z"
        fill={color}
      />
      <path
        d="M21.7208 16.4157L22.0913 18H23.1635L24 14H23.1916L22.9053 15.4551C22.7855 16.0618 22.6882 16.6386 22.6134 17.1854H22.6022C22.5011 16.6199 22.3795 16.0431 22.2373 15.4551L21.8892 14H20.845L20.497 15.4551C20.3548 16.0431 20.2331 16.6199 20.1321 17.1854H20.1208C20.046 16.6386 19.9487 16.0618 19.8289 15.4551L19.5426 14H18.7342L19.5707 18H20.6429L21.0134 16.4157C21.1519 15.8277 21.2679 15.2566 21.3615 14.7022H21.3727C21.4663 15.2566 21.5823 15.8277 21.7208 16.4157Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16ZM27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16Z"
        fill={color}
      />
    </svg>
  );
}
